import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface ImpressumLocation {
  city: string;
  company: string;
  addressLines: string[];
  phones: string[];
  faxes: string[];
  email: string;
  website: string;
  representatives: string[];
  register: string;
  vatId: string;
  vsbgCompany: string;
}

export const IMPRESSUM_LOCATIONS: Record<string, ImpressumLocation> = {
  '225': {
    city: 'Leer',
    company: 'Creditreform Leer Bolte KG',
    addressLines: ['Hauptstr. 16', 'D-26789 Leer'],
    phones: ['+49 (0) 491 97 98-20'],
    faxes: ['+49 (0) 491 97 98-250'],
    email: 'info@leer.creditreform.de',
    website: 'https://www.creditreform.de/leer',
    representatives: ['Christian Bolte'],
    register: 'Handelsregister: Amtsgericht Aurich HRA 110043',
    vatId: 'USt-IdNr.: DE 117272031',
    vsbgCompany: 'Creditreform Leer Bolte KG',
  },
  '237': {
    city: 'Oldenburg',
    company: 'Creditreform Oldenburg Bolte KG',
    addressLines: ['Neue Donnerschweer Str. 36', 'D-26123 Oldenburg'],
    phones: ['+49 (0) 491 97 98-20', '+49 (0) 441 973 99-0'],
    faxes: ['+49 (0) 491 97 98-250', '+49 (0) 441 973 99-40'],
    email: 'info@oldenburg.creditreform.de',
    website: 'https://www.creditreform.de/oldenburg',
    representatives: ['Michael Bolte'],
    register: 'Handelsregister: Amtsgericht Oldenburg HRA 2686',
    vatId: 'USt-IdNr.: DE 117488409',
    vsbgCompany: 'Creditreform Oldenburg Bolte KG',
  },
  '217': {
    city: 'Hameln',
    company: 'Creditreform Hameln Bolte KG',
    addressLines: ['Ostertorwall 38', 'D-31785 Hameln'],
    phones: ['+49 (0) 5151 55790-0'],
    faxes: ['+49 (0) 5151 144-49'],
    email: 'info@hameln.creditreform.de',
    website: 'https://www.creditreform.de/hameln',
    representatives: ['Heinz Bolte', 'Matthias Bolte'],
    register: 'Handelsregister: Amtsgericht Hannover HRA 100 140',
    vatId: 'USt-IdNr.: DE 264 729 052',
    vsbgCompany: 'Creditreform Hameln Bolte KG',
  },
  '429': {
    city: 'Paderborn',
    company: 'Creditreform Paderborn Davis & Bolte KG',
    addressLines: ['Am Hoppenhof 30', 'D-33104 Paderborn'],
    phones: ['0 52 51 / 1 37 06 -0'],
    faxes: ['0 52 51 / 13 70 6 -24'],
    email: 'info@paderborn.creditreform.de',
    website: 'http://www.creditreform.de/paderborn',
    representatives: ['Anja Davis', 'Michael Bolte', 'Christian Bolte'],
    register: 'Handelsregister: Amtsgericht Paderborn HRA 11 27',
    vatId: 'USt-IdNr.: DE 126317470',
    vsbgCompany: 'Creditreform Paderborn Davis & Bolte KG',
  },
  '413': {
    city: 'Gütersloh',
    company: 'Creditreform Gütersloh Bolte KG',
    addressLines: ['Moltkestr. 3-7', 'D-33330 Gütersloh'],
    phones: ['+49 (0) 52 41 / 22 07 -0'],
    faxes: ['+49 (0) 52 41 / 22 07 - 222'],
    email: 'info@guetersloh.creditreform.de',
    website: 'https://www.creditreform.de/guetersloh',
    representatives: ['Matthias Bolte', 'Michael Bolte'],
    register: 'Handelsregister: Amtsgericht Gütersloh HRA 2869',
    vatId: 'USt-IdNr.: DE 220399509',
    vsbgCompany: 'Creditreform Gütersloh Bolte KG',
  },
};

const DEFAULT_IMPRESSUM_LOCATION: ImpressumLocation = {
  ...IMPRESSUM_LOCATIONS['225'],
  company: 'Chatbot Bolte GbR',
  vsbgCompany: 'Chatbot Bolte GbR',
  addressLines: ['Schlosslohne 27', '26789 Leer'],
  phones: [],
  faxes: [],
  email: '',
  website: '',
};

export function getImpressumLocationCompany(standortClz: string): string {
  return IMPRESSUM_LOCATIONS[standortClz]?.company ?? '';
}

@Component({
  selector: 'app-impressum-modal',
  standalone: true,
  templateUrl: './impressum-modal.component.html',
  styleUrl: './impressum-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpressumModalComponent {
  @Input() standortClz = '';
  @Output() close = new EventEmitter<void>();

  get location(): ImpressumLocation {
    return IMPRESSUM_LOCATIONS[this.standortClz] ?? DEFAULT_IMPRESSUM_LOCATION;
  }

  websiteLabel(website: string): string {
    return website.replace(/^https?:\/\//, '');
  }

  onClose(): void {
    this.close.emit();
  }
}
